<div class="page-container  gray-200">
    <section>
      <div class="content-band  max-w1440">
        <div class="container">
          <div>
            <!-- <app-bread-crumb></app-bread-crumb> -->
        </div>
          <div>
            <!-- <app-role-request-new-role></app-role-request-new-role> -->
            <router-outlet></router-outlet>
            <!-- <app-role-request-add-employee-role></app-role-request-add-employee-role>
            <br> -->

            <!-- <app-role-request-new-role></app-role-request-new-role> -->
            <!-- <app-role-request-remove-role></app-role-request-remove-role> -->
            <!-- <app-role-request-remove-employee-role></app-role-request-remove-employee-role> -->
            <!-- <app-role-request-manage-request></app-role-request-manage-request> -->
             <!-- <app-role-request-advanced-search></app-role-request-advanced-search> -->
             <!-- <app-role-request-employee-overview></app-role-request-employee-overview> -->
            <!-- 
            <br>
         
         
            <app-role-request-advanced-search></app-role-request-advanced-search>
            <br>
            
            <app-role-request-remove-role></app-role-request-remove-role>
            <br>
            <app-role-request-remove-employee-role></app-role-request-remove-employee-role>
            <br>
            <app-role-request-manage-request></app-role-request-manage-request>
            <br>
          
            <app-role-request-overview></app-role-request-overview>
            <br>
            <app-role-request-success></app-role-request-success>
            <br>
            <app-role-request-add-employee-role></app-role-request-add-employee-role>
            <br>
            <app-role-request-home></app-role-request-home>
            <br>
           -->
            <br> 
          </div>
        </div>
      </div>
    </section>
  </div>
  

